"use strict";import{ColorLoupe as o}from"./src/ColorLoupe.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-color-loupe",o);
//# sourceMappingURL=sp-color-loupe.js.map
